export const RATE_FALLBACK = { USD: 1, INR: 83.2, EUR: 0.92, GBP: 0.79, AED: 3.67 };

export const CURRENCIES = ["INR"];

export const CURRENCY_SYMBOLS = { INR: "₹", USD: "$", EUR: "€", GBP: "£", AED: "د.إ" };

export function convertAmount(amount, from, to, rates) {
  const r = rates || RATE_FALLBACK;
  const a = Number(amount) || 0;
  const rf = r[(from || "USD").toUpperCase()] || 1;
  const rt = r[(to || "USD").toUpperCase()] || 1;
  return (a / rf) * rt;
}

function localeFor(c) {
  return c === "INR" ? "en-IN" : "en-US";
}

export function formatMoney(amount, currency = "USD", { compact = false } = {}) {
  const value = Number(amount) || 0;
  try {
    return new Intl.NumberFormat(localeFor(currency), {
      style: "currency",
      currency,
      maximumFractionDigits: compact ? 1 : 2,
      minimumFractionDigits: 0,
      notation: compact ? "compact" : "standard",
    }).format(value);
  } catch {
    return `${CURRENCY_SYMBOLS[currency] || ""}${value.toLocaleString()}`;
  }
}

export function formatPercent(n) {
  const v = Number(n) || 0;
  return `${v > 0 ? "+" : ""}${v}%`;
}

export function formatDate(d) {
  if (!d) return "—";
  const date = new Date(d);
  if (isNaN(date.getTime())) return String(d);
  return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}
